module.exports = __webpack_public_path__ + "static/media/vontrapp.b6269d65.jpg";